import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import Button from "@mui/material/Button";
import { TextFieldMask, PasswordField, Checkbox, LinkLabel, LoginTimer } from "TemplateCerere";
import { ArrowRight } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import OtpInput from "react-otp-input";
import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

const PhonePage = (props) => {
   const {
    updateAcord,
    updateValue,
    handlerUpdate,
    codeRequest,
    sendPhone,
    confirmPhone,
    state,
    downloadAcord,
    register,
    agreement,
    firstDigits,
    lastDigits,
    setFirstDigits,
    setLastDigits
  } = props;

  const actions = { downloadAcord };
  

  return (
    <React.Fragment>
      {register?.title && <p className="page-title">{register?.title}</p>}
      {register?.subtitle && <p className="normal-text">{register?.subtitle}</p>}
      {register?.subtitle2 && (
        <p className="normal-text">{register?.subtitle2}</p>
      )}
      <form className="form">
        {register?.cnp && (
          <PasswordField
            id="cnp"
            autoComplete="numar cnp"
            label={register.cnp.label || "CNP/NIF"}
            variant="outlined"
            margin="normal"
            required
            defaultValue={state.cnp?.value ?? ""}
            className="login-pwd"
            onBlur={(prop) => updateValue("cnp", prop.target.value)}
            mask={"0000000000000"}
            error={!!state.cnp.error}
            type="text"
            helperText={register.cnp.helperText}
          />
        )}
      </form>
      {register?.amCard && (
        <>
          {!register?.mandatoryCard &&
            <div className="form switch-group">
              <div className="label">Detin card de debit la Patria Bank:</div>
              <FormControlLabel
                control={
                  <Switch
                    id="sc"
                    color="primary"
                    width="100px"
                    checked={state.showCard}
                    onChange={(prop) => {
                      handlerUpdate("showCard", prop.target.checked);
                    }}
                  />
                }
                label={state.showCard ? "Da" : "Nu"}
                labelPlacement="top"
              />
            </div>
          }
          {state.showCard &&
            <div className="form">
          <Typography className="label">Numarul Cardului</Typography>
          <div className="hlist">
            <TextFieldMask
              variant="outlined"
              margin="normal"
              required
              id="firstDigits"
              label="Primele 4 Cifre"
              className="card center"
              defaultValue={firstDigits}
              onBlur={(prop) => setFirstDigits(prop.target.value)}
              mask="0000"
             

            />
            <TextFieldMask
              id="m1"
              variant="outlined"
              margin="normal"
              defaultValue="* * * *"
              className="card disabled center"
              disabled
            />
            <TextFieldMask
              id="m2"
              variant="outlined"
              margin="normal"
              defaultValue="* * * *"
              className="card disabled center"
              disabled
            />

            <TextFieldMask
              variant="outlined"
              margin="normal"
              required
              id="lastDigits"
              label="Ultimele 4 Cifre"
              className="card center"
              defaultValue={lastDigits}
              onBlur={(prop) =>  setLastDigits(prop.target.value)}
              mask="0000"
            />
          </div>
        </div>
          }
        </>
      )}
      {agreement?.a1?.label && (
        <div className="acord">
          <Checkbox
            id="a1"
            checked={state.acord?.a1}
            onChange={updateAcord}
            color="primary"
          />
          <div className="acord-txt">
            <LinkLabel
              id="a1l"
              linkClick={agreement.a1.linkClick}
              actions={actions}
              label={agreement.a1.label}
            />
            <FormHelperText id="a1e" error={!!state.acord?.a1_err}>{state.acord?.a1_err}</FormHelperText>
          </div>
        </div>
      )}
      {agreement?.a2?.label && (
        <div className="acord">
          <Checkbox
            id="a2"
            checked={state.acord?.a2}
            onChange={updateAcord}
            color="primary"
          />
          <div className="acord-txt">
            <LinkLabel
              id="a2l"
              linkClick={agreement.a2.linkClick}
              actions={actions}
              label={agreement.a2.label}
            />
            <FormHelperText id="a2e" error={!!state.acord?.a2_err}>{state.acord?.a2_err}</FormHelperText>
          </div>
        </div>
      )}
      {agreement?.a3?.label && (
        <div className="acord">
          <Checkbox
            id="a3"
            checked={state.acord?.a3}
            onChange={updateAcord}
            color="primary"
          />
          <div className="acord-txt">
            <LinkLabel
              id="a3l"
              linkClick={agreement.a3.linkClick}
              actions={actions}
              label={agreement.a3.label}
            />
            <FormHelperText id="a3e" error={!!state.acord?.a3_err}>{state.acord?.a3_err}</FormHelperText>
          </div>
        </div>
      )}
      <form className="form">
        <TextFieldMask
          autoComplete="numar phone"
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="phone"
          label="Nr Telefon"
          defaultValue={state.phone?.value ?? "07"}
          onBlur={(prop) => updateValue("phone", prop.target.value)}
          className="phone"
          mask={"\\0799999999"}
          error={!!state.phone.error}
          helperText={state.phone.error}
          type="tel"
        />
      </form>
      <p className="footer-text mkt">
        Campurile marcate cu * sunt obligatoriu de completat
      </p>
      <Button
        id="trimite"
        variant="contained"
        color="primary"
        className="login-btn"
        onClick={sendPhone}
        endIcon={<ArrowRight fontSize="large" />}
      >
        Trimite Cod
      </Button>
      <Typography variant="subtitle2">
        Introdu codul primit prin SMS:
      </Typography>
      <OtpInput
        value={state.smsCode ?? ""}
        onChange={(value) => updateValue("smsCode", value)}
        numInputs={6}
        renderInput={(props) => <input {...props} disabled={!!codeRequest} />}
        inputStyle="MuiInputBase-root MuiInputBase-input MuiOutlinedInput-input otp-input"
        focusStyle="otp-focus"
        disabledStyle="MuiInputBase-root Mui-disabled"
        inputType="number"
        containerStyle="otp"
      />
      <FormHelperText id="err" error={false}></FormHelperText>
       <LoginTimer sendPhone={sendPhone} />
      <Button
         id="confirma"
        variant="contained"
        color="primary"
        onClick={confirmPhone}
        endIcon={<ArrowRight fontSize="large" />}
        disabled={!state.smsCode}
      >
        Confirma telefon
      </Button>
    </React.Fragment>
  );
};

export default observer(PhonePage);
